import React, {Component} from 'react';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import {Timeline, Icon, Progress} from 'antd';

class ProgressTimeline extends Component{
  renderGhostIndicator(){
    return (
      <span>
      {
        this.props.steps.length <= 4 
        &&
        <span>pending...</span>
      }
      {
        this.props.steps.length === 5 
        &&
        <span>Complete</span>
      }
      </span>
    );
  }
    
  render(){
    const {steps, progress} = this.props;
    return (
      <div>
        <div css={css`
          width: 100%;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          justify-content: space-between;
        `}>
          <div css={css`
            min-width: 48%;
            box-shadow: 0 1px 4px rgba(0,0,0,0.2);
            display: flex;
            flex-direction: column;
            flex-wrap: nowrap;
            justify-content: flex-start;
          `}>
              <div css={css`
                text-align: center;
                padding: 15px 0px;
                font-size: 1.2rem;
                font-weight: 600;
                margin: 0px 0px 10px 0px;
                background-color: #B3E5FC;
              `}>Overall Progress </div>
              <Timeline
                style={{marginLeft: 30,}}
                pending={this.renderGhostIndicator()}>
                {
                  steps.map((value,index)=>
                    <Timeline.Item 
                      dot={<Icon 
                        type="clock-circle-o" 
                        style={{ fontSize: '16px' }} />} 
                      color="green" 
                      key={index}>
                      {value}
                    </Timeline.Item>)
                }
              </Timeline>
          </div>

          <div css={css`
            min-width: 48%;
            box-shadow: 0 1px 4px rgba(0,0,0,0.2);
            display: flex;
            flex-direction: column;
            flex-wrap: nowrap;
            justify-content: space-between;
          `}>
            <div css={css`
              text-align: center;
              padding: 15px 0px;
              font-size: 1.2rem;
              font-weight: 600;
              margin: 0px 0px 10px 0px;
              background-color: #B3E5FC;
            `}>Workflow Completion </div>
            {
              progress.map((value,index)=>
              <div key={index}
                css={css`
                  margin: 10px 0px;
                  padding: 10px;
                `}>
                <div>{value[0]}</div>
                <Progress percent={value[1]} strokeWidth={5} />
              </div>)
            }
          </div> 
        </div>
      </div>
    );
  }
}

export default ProgressTimeline;